import React from 'react';
import { WebView } from 'react-native-webview';
import { View, StyleSheet } from 'react-native';

const NFSigScreen = () => {
  return (
    <View style={styles.container}>
      <WebView
        source={{ uri: 'https://nfsigcliente.brasalrefrigerantes.com.br/' }}
        style={{ flex: 1 }}
        startInLoadingState
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: { flex: 1 }
});

export default NFSigScreen;
